import { containsExpressions, hasProperty, hasValue, parseValue } from "../../util";
import { ISerializedUIField, IWidgetTemplateProps } from "./common";
import { IDropdownFieldProperty } from "./ui-fields/dropdown/Dropdown";
import { executeAndBind } from "./data-source-picker/datasource";
import { formatFieldPath, IContextData } from "../../hooks/useContextData";

export async function getAllValuesForDropDown(parentProps: IWidgetTemplateProps, props: IDropdownFieldProperty, data: any) {
    console.log('calling to get all values ', props.binding)
    const _data = await executeAndBind(parentProps.uxpContext, props.binding, parentProps.uiProps?.datasources, data)
    if (!_data) return []
    return _data.map((d: any) => d[props.valueField || 'value'])
}
export async function extractDataFromFields(props: IWidgetTemplateProps, contextData: IContextData, fields: ISerializedUIField[], dataKey: string = 'form'): Promise<IContextData> {
    const _contextData = { ...contextData };

    if (!hasProperty(_contextData, `$.${dataKey}`)) {
        _contextData[dataKey] = {};
    }

    const inputs = fields.filter(f => f.isInputField);

    for (const field of inputs) {
        const fieldPath = formatFieldPath(`$.${dataKey}`, field.id);

        if (!hasProperty(_contextData, fieldPath) || containsExpressions(_contextData[dataKey][field.id])) {
            let val = _contextData[dataKey][field.id] ?? field.props?.value ?? null;
            if (typeof val == 'string' && containsExpressions(val)) {
                val = parseValue(val, _contextData)
            }

            // Set default values based on field type
            switch (field.type) {
                case 'date':
                case 'time':
                case 'datetime':
                    if (!hasValue(val)) val = new Date();
                    break;

                case 'daterange':
                    const now = new Date();
                    val = val || {};
                    if (!val.start) val.start = now;
                    if (!val.end) val.end = now;
                    // Store as ISO strings so expressions like {$.filters.myDate.start} render safely
                    val = {
                        start: val.start instanceof Date ? val.start.toISOString() : val.start,
                        end: val.end instanceof Date ? val.end.toISOString() : val.end,
                    };
                    break;

                case 'number':
                    if (!hasValue(val, true, field?.props?.allowNegativeValues)) {
                        val = field.props?.minValue ? Number(field.props.minValue) : 0;
                    }
                    break;

                case 'checkbox':
                    if (val === null) val = false;
                    break;

                case 'multiple-select':
                    if ((field.props as IDropdownFieldProperty).selectAllOnLoad) {
                        val = await getAllValuesForDropDown(props, field.props, contextData);
                    }
                    break;
            }

            _contextData[dataKey][field.id] = val;
        }
    }

    return _contextData;
}
